import { TextDefault } from "./text-default";
import { TextLinear } from "./text-linear";

export const Text = TextDefault;
export { TextLinear };

export default Text;
